import { apiFGTS } from "../http/httpClient";
export interface createPublicTransactionBody {
  value: number;
  customerId: string;
  CodigoTabela: string;
  CodigoProduto: number;
  CodigoEmpregador: number;
  CodigoOrg: number;
  Prazo: number;
  linkName: string;
}

interface createPublicTransactionResponse {
  contract: string;
  value: number;
  status: string;
  seller: string;
  customer: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export async function createPublicTransaction(
  body: createPublicTransactionBody,
) {
  const { data } = await apiFGTS
    .post<createPublicTransactionResponse>(`/self-hire/transaction`, body)
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
